import * as React from 'react';
import { useMediaQuery } from 'react-responsive';

import { BadgeSize, BadgeTheme, Breakpoint, Color } from '../../enums';
import { BadgeDetails } from '../../interfaces';
import { Icon } from '../icon/icon.component';

import { BadgeContainer, Container, IconContainer, LabelContainer } from './circleBadges.styled';
import { CircleBadgesProps } from './circleBadges.types';

export const CircleBadges: React.FC<CircleBadgesProps> = (props: CircleBadgesProps): JSX.Element => {
  const { className, badges, badgesTheme = BadgeTheme.Gray, size = BadgeSize.Small }: CircleBadgesProps = props;
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });

  return (
    <Container className={className}>
      {badges.map((badge: BadgeDetails): JSX.Element => (
        <BadgeContainer className={className} key={badge.label}>
          <IconContainer $theme={badgesTheme} $size={size}>
            <Icon
              name={badge.icon}
              size={(size === BadgeSize.Small || isSmallMobile) ? 18 : 25}
              color={badge.color ?? Color.Error500}
            />
          </IconContainer>
          <LabelContainer $size={size}>{badge.label}</LabelContainer>
        </BadgeContainer>
      ))}
    </Container>
  );
};
